/**
 * The sidebar's "Apps" group: the separate apps this person was given, from
 * the session answer (`SessionInfo.apps`). Generic on purpose: the platform's
 * bundle names no app; the label and the link arrive in JSON, and only for
 * the people who hold one.
 */
import { AppWindowIcon, BriefcaseIcon, type LucideIcon } from "lucide-react";
import type { PlatformApp, PlatformAppIcon } from "@scandi/shared";

const ICONS: Record<PlatformAppIcon, LucideIcon> = { briefcase: BriefcaseIcon, app: AppWindowIcon };

export interface AppNavItem {
  id: string;
  label: string;
  href: string;
  icon: LucideIcon;
}

/** The entries to draw, safe against an answer from another build: same-origin paths only. */
export function appNavItems(apps: readonly PlatformApp[] | undefined): AppNavItem[] {
  return (apps ?? [])
    .filter((app) => typeof app.href === "string" && app.href.startsWith("/") && !app.href.startsWith("//"))
    .map((app) => ({ id: app.id, label: app.label, href: app.href, icon: ICONS[app.icon] ?? AppWindowIcon }));
}

/** Whether `pathname` belongs to one of the apps, so a sign-in there reloads into it. */
export function appForPath(apps: readonly PlatformApp[] | undefined, pathname: string): AppNavItem | null {
  return appNavItems(apps).find((app) => pathname === app.href || pathname.startsWith(`${app.href}/`)) ?? null;
}
